import '../styles/main.scss';
import Util from './modules/Utilities';
import Sliders from './modules/Sliders';
import Animations from './modules/Animations';
import TitleAnimation from './modules/TitleAnimation';
import Cursor from './modules/Cursor';

document.addEventListener('DOMContentLoaded', () => {
  Util.forEachPolyfill();
  Util.anchorsInit();
  Util.addTargetBlank();
  new Animations();

  Sliders.gallery();
  Sliders.figures();

  new TitleAnimation({base: '.hero', box: '.hero-box'});

  if (!('ontouchstart' in window || navigator.msMaxTouchPoints)) {
    new Cursor('.cursor', 50);
  }
})
